import type {
  CareerHubBrand,
  CareerHubCountry,
  CareerHubLanguage,
  CareerHubLocale,
  CareerHubZones,
} from 'src/types';

declare global {
  interface Window {
    __CONFIG_STATE__: Record<string, any>;
  }
}

const getConfigItem = (configItem: string, fallback?: string) => {
  const isServer = typeof window === 'undefined';
  if (!isServer && window.__CONFIG_STATE__) {
    const keys = configItem.split('.'); // Handle nested properties
    let result = window.__CONFIG_STATE__;

    for (const key of keys) {
      if (result[key] !== undefined) {
        result = result[key];
      } else {
        return fallback;
      }
    }
    return result;
  }
  return fallback;
};

const getWindowLocation = () => {
  const isServer = typeof window === 'undefined';
  if (!isServer && window.location) {
    return window.location;
  }
  return null;
};

export const getSite = (): string => getConfigItem('site') as string;

export const getLocale = (): CareerHubLocale =>
  getConfigItem('locale', 'en-MY') as CareerHubLocale;

export const getLanguage = (): CareerHubLanguage =>
  getConfigItem('locale', 'en-MY')?.split('-')[0] as CareerHubLanguage;

export const getEnvironment = (): string =>
  getConfigItem('environment', 'development') as string;

export const getZone = (): CareerHubZones =>
  getConfigItem('zone', 'asia-5') as CareerHubZones;

export const getCountryName = (): string =>
  getConfigItem('countryCode', 'Malaysia') as CareerHubCountry;

export const getCountryCode = (): string =>
  getConfigItem('countryCode', 'MY')?.toUpperCase() as string;

export const isLocal = (): boolean => {
  const loc = getWindowLocation();
  return Boolean(loc && loc.hostname.startsWith('dev.'));
};

export const locationOrigin = (): string | null => {
  const loc = getWindowLocation();
  return loc && loc.origin;
};

export const getBrand = (): CareerHubBrand =>
  getConfigItem('brand', 'jobstreet') as CareerHubBrand;
